module.exports = __webpack_public_path__ + "static/media/1871.31ecd87a.png";